import './style.css';
import { MapTilerMap } from './maptiler/MapTilerMap';
import {
    BaseMaps,
    ControlPosition,
    getDefaultMap,
} from './maptiler/MapTilerConstants';
import { Actions } from './maptiler/factories/ActionFactory';
import { Controls } from './maptiler/factories/ControlFactory';
import { Layers } from './maptiler/factories/LayerFactory';
import { Sources } from './maptiler/factories/SourceFactory';
import { Settings } from './Settings';
import { Tools } from './Tools';

const apiKey = Settings.apiKey();
const mapContainer = 'map';
const mapStyle = getDefaultMap().style;
const mapCenter = [8.89, 47.24];
const mapZoom = 13;

const map = new MapTilerMap(apiKey, mapContainer, mapStyle, mapCenter, mapZoom);

const layerSwitcherControl = Controls.layerSwitcherControl(
    BaseMaps,
    getDefaultMap()
);
map.addControl(layerSwitcherControl, ControlPosition.BOTTOM_LEFT);

if (Settings.popupOnClick()) {
    map.addClickAction(Actions.showCoordinates());
}

map.addStaticDataLayers(
    'swimming-course',
    Sources.swimmingCourse(),
    Layers.swimmingCourse()
);

map.addStaticDataLayers(
    'bike-course',
    Sources.bikeCourse(),
    Layers.bikeCourse()
);

map.addStaticDataLayers(
    'bike-checkpoints',
    Sources.bikeCheckpoints(),
    Layers.bikeCheckpoints()
);

map.addStaticDataLayers(
    'running-course',
    Sources.runningCourse(),
    Layers.runningCourse()
);

map.addStaticDataLayers(
    'running-checkpoints',
    Sources.runningCheckpoints(),
    Layers.runningCheckpoints()
);

if (Settings.showTracker()) {
    const unitsAndZoomControl = Controls.unitsAndZoomControl(
        BaseMaps,
        getDefaultMap()
    );
    map.addControl(unitsAndZoomControl, ControlPosition.TOP_LEFT);

    const swimmingCourseExtent = Tools.getExtentFromGeojsonSource(
        Sources.swimmingCourse()
    );
    const bikeCourseExtent = Tools.getExtentFromGeojsonSource(
        Sources.bikeCourse()
    );
    const runningCourseExtent = Tools.getExtentFromGeojsonSource(
        Sources.runningCourse()
    );
    const combinedExtent = Tools.getCombinedExtent(
        swimmingCourseExtent,
        bikeCourseExtent,
        runningCourseExtent
    );
    unitsAndZoomControl.addZoomButton('SWIM', swimmingCourseExtent);
    unitsAndZoomControl.addZoomButton('BIKE', bikeCourseExtent);
    unitsAndZoomControl.addZoomButton('RUN', runningCourseExtent);
    unitsAndZoomControl.addZoomButton('ALLE', combinedExtent);

    map.addDynamicDataLayers(
        'fzm-positions',
        Settings.getApiUrl('positions-fzm'),
        Layers.fzmTrackerPositions()
    );

    map.addDynamicDataLayers(
        'traccar-positions',
        Settings.getApiUrl('positions-combined'),
        Layers.traccarTrackerPositions()
    );

    map.setDynamicDataRefreshRate(10000);
}
